import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useSnackbar } from '@components/snackbar';
import { Input } from '@components/text-input';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { WhiteBoardFileIcon, WhiteboardImageIcon, WhiteboardLinkIcon } from '@sketchnote/icons';
import { Button, Panel as Panel2, Tabs } from '@sketchnote/shared-components';
import * as React from 'react';
import { ToolButton, useTldrawApp } from 'sn-wb-tldraw';

import { fetchMetaDataFromUrl } from '../../api/getParsedUrl';
export const LinkUpload = React.memo(function LinkUpload(): JSX.Element {
  const app = useTldrawApp();
  const [openSnackbar] = useSnackbar();
  const [inputUrl, setInputUrl] = React.useState('');
  const isSmallScreen = window.innerHeight < 800;

  const createLink = async () => {
    const response = await fetchMetaDataFromUrl(inputUrl);
    if (!response) {
      openSnackbar({
        text: `Invalid Url`,
        snackType: 'error',
        position: 'bottom-center',
        duration: 1500,
      });
      return;
    }
    if (response.data.mediaType.includes('video')) {
      app.createVideoEmbed(response.data);
      return;
    }
    app.createLink(response.data);
  };

  const handleUrl = (e) => {
    setInputUrl(e.target.value);
  };
  return (
    <Menu placement="right" direction="ltr" isLazy offset={[0, 15]}>
      <div>
        <MenuButton
          className="h-36 w-36 smallScreen:w-23 smallScreen:h-23 flex justify-center items-center cursor-pointer"
          style={{
            border: '0.79px solid #E2E4E9',
            borderRadius: '3.17241px',
          }}
        >
          <WhiteboardLinkIcon wrapperClass={'transform smallScreen:scale-60'} />
        </MenuButton>
        <p
          style={{
            fontSize: `${isSmallScreen ? '8px' : '12.48px'}`,
            textAlign: 'center',
            lineHeight: `${isSmallScreen ? '16px' : '24.96px'}`,
          }}
        >
          Link
        </p>
      </div>

      <MenuList>
        <div className="flex flex-col py-10 px-12 gap-10 rounded-lg bg-white shadow-sm text-gray-999 min-w-284">
          <p className="font-medium text-sm m-0 text-gray-600">Add a Link</p>
          <Input onChange={handleUrl} />
          <div style={{ width: 'auto' }}>
            <MenuItem>
              <Button onClick={createLink} className="justify-center">
                Add
              </Button>
            </MenuItem>
          </div>
        </div>
      </MenuList>
    </Menu>
  );
});
